export default __webpack_public_path__ + "static/media/carelogic-mobile-logo.8a7a7d77.png";